import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Table, TableBody, TableCell, TableRow } from "@/components/ui/table";

interface RowDetailsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description?: string;
  cells: Record<string, string>;
}

export function RowDetailsDialog({
  open,
  onOpenChange,
  title,
  description,
  cells,
}: RowDetailsDialogProps) {
  const entries = Object.entries(cells);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[85dvh] w-[95vw] max-w-3xl overflow-hidden p-0">
        <DialogHeader className="border-b px-6 py-4">
          <DialogTitle>{title}</DialogTitle>
          {description ? <DialogDescription>{description}</DialogDescription> : null}
        </DialogHeader>
        <div className="overflow-auto px-6 py-4">
          <Table>
            <TableBody>
              {entries.map(([header, value]) => (
                <TableRow key={header}>
                  <TableCell className="w-[240px] align-top font-medium">{header}</TableCell>
                  <TableCell className="whitespace-pre-wrap break-words">
                    {value || <span className="text-muted-foreground"> </span>}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </DialogContent>
    </Dialog>
  );
}
